import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as Parse from 'parse';

@Injectable()
export class OfferService {

    constructor(private auth: AuthService) {
    }

    createInstantOffer(customerId: string, price: number, name: string, phone: string, propertyId: string, organizationId: string) {
        return Parse.Cloud.run('createInstantOffer', {
            customerId: customerId,
            price: price,
            name: name.trim().toLowerCase(),
            phone: phone.trim().replace(/\D+/g, ''),
            propertyId: propertyId,
            organizationId: organizationId
        });
    }

    fetchOffersForProperty(property: Parse.Object, pageIndex: number, pageSize: number) {
        const query: Parse.Query = new Parse.Query('InstantOffer');

        query.limit(pageSize);
        query.skip(pageSize * pageIndex);
        query.equalTo('property', property);
        query.equalTo('organization', property.get('organization'));

        query.descending('createdAt');

        // Admins will include customer
        if (this.auth.userType === 'Admin') {
            query.include('customer');
        }

        // SAs only see their own offers.
        if (this.auth.userType === 'SA') {
            query.equalTo('preferredAgent', this.auth.currentUser);
            query.include('customer');
        }

        query.withCount();

        return query.find();
    }

    fetchCustomerOwners(agentIds: string[]) {
        return Parse.Cloud.run('fetchCustomerOwners', { customerIds: agentIds });
    }
}
